/**
 * Whether Ask ELSA is drawn for this user (AB#21422).
 *
 * The backend decides — `features.ask_elsa` on the authuser response — and
 * its routes refuse the same people with a 403. This mirror exists for the
 * window where the portal has deployed and the backend has not yet: an
 * authuser response with no `features` block is read the way the backend
 * reads it, so a merchant admin never sees the section for the length of a
 * deploy. Once the flag is present it wins, and this list is not consulted.
 *
 * Merchant side, factory side and shop customers are outside the desk. A
 * role nobody has invented yet sits at the desk — the same fail-open-for-
 * staff shape the backend has, for the same AB#21151 reason.
 */

const EXTERNAL_ROLES = new Set([
  'admin',
  'manager',
  'adminsalesrep',
  'merchantgroupadmin',
  'factory',
  'logisticassistant',
  'customer',
]);

const SUPER_ROLES = new Set(['superadmin', 'limitedsuperadmin']);

export interface ElsaFeatures {
  ask_elsa?: boolean;
}

export const elsaAllowed = (
  roles: ReadonlyArray<{ name?: string | null }> | null | undefined,
  features?: ElsaFeatures | null
): boolean => {
  if (typeof features?.ask_elsa === 'boolean') return features.ask_elsa;

  const names = (roles ?? []).map((r) => String(r?.name ?? '').toLowerCase()).filter(Boolean);
  if (names.length === 0) return false;
  if (names.some((n) => SUPER_ROLES.has(n))) return true;

  return !names.some((n) => EXTERNAL_ROLES.has(n));
};
